import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const ShopifyOrderStatus = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [selectedStatus, setSelectedStatus] = useState<string>(actionStep?.action?.data.status || "Completed");
    const dispatch = useAppDispatch();

    const handleStatusClick = (status: string) => {
        setSelectedStatus(status);
    };

    useEffect(() => {
        const action = {type: ActionType.SHOPIFY_ORDER_STATUS, data: {status: selectedStatus}};
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, selectedStatus]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText text="What status do you want to update the order to:" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => handleStatusClick("Completed")}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Completed" size="s" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox
                        callback={() => {}}
                        checked={selectedStatus === "Completed"}
                        label=""
                        value=""
                        custom={false}
                    />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => handleStatusClick("Processing")}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Processing" size="s" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox
                        callback={() => {}}
                        checked={selectedStatus === "Processing"}
                        label=""
                        value=""
                        custom={false}
                    />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => handleStatusClick("Draft")}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Draft" size="s" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={selectedStatus === "Draft"} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => handleStatusClick("Pending payment")}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Pending payment" size="s" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox
                        callback={() => {}}
                        checked={selectedStatus === "Pending payment"}
                        label=""
                        value=""
                        custom={false}
                    />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => handleStatusClick("Shipping")}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Shipping" size="s" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox
                        callback={() => {}}
                        checked={selectedStatus === "Shipping"}
                        label=""
                        value=""
                        custom={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default ShopifyOrderStatus;
